export default "__VITE_ASSET__BqupPBXV__"